<template>
  <header class="navbar">
    <div class="navbar-container">
      <!-- Logo -->
      <router-link to="/" class="navbar-brand">
        <div class="navbar-logo">
          <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z"/>
          </svg>
        </div>
        <span class="navbar-title hidden-mobile">pruksamarket</span>
      </router-link>

      <!-- Desktop Navigation -->
      <nav class="navbar-nav desktop">
        <router-link to="/" class="nav-link">หน้าแรก</router-link>
        <router-link to="/products" class="nav-link">สินค้า</router-link>
        <router-link to="/track" class="nav-link">ติดตามคำสั่งซื้อ</router-link>
      </nav>

      <!-- Actions -->
      <div class="navbar-nav">
        <!-- Cart -->
        <router-link to="/cart" class="nav-icon cart-badge">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
          </svg>
          <span v-if="cartStore.itemCount > 0" class="cart-count">{{ cartStore.itemCount }}</span>
        </router-link>

        <!-- Auth Buttons (Desktop) -->
        <template v-if="!authStore.isAuthenticated">
          <router-link to="/login" class="btn btn-ghost btn-sm hidden-mobile">เข้าสู่ระบบ</router-link>
          <router-link to="/register" class="btn btn-primary btn-sm hidden-mobile">สมัครสมาชิก</router-link>
        </template>
        <template v-else>
          <router-link to="/member/profile" class="nav-icon hidden-mobile" title="บัญชีของฉัน">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            </svg>
          </router-link>
        </template>

        <!-- Mobile Menu Button -->
        <button @click="openMenu" class="mobile-menu-btn">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"/>
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile Menu Overlay -->
    <div class="mobile-menu-overlay" :class="{ open: showMenu }" @click="closeMenu"></div>

    <!-- Mobile Menu -->
    <div class="mobile-menu" :class="{ open: showMenu }">
      <div class="mobile-menu-header">
        <span class="mobile-menu-title">เมนู</span>
        <button @click="closeMenu" class="mobile-menu-close">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <nav>
        <router-link to="/" class="mobile-nav-link" @click="closeMenu">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-4 0a1 1 0 01-1-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 01-1 1h-2z"/>
          </svg>
          หน้าแรก
        </router-link>

        <router-link to="/products" class="mobile-nav-link" @click="closeMenu">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
          </svg>
          สินค้าทั้งหมด
        </router-link>

        <router-link to="/track" class="mobile-nav-link" @click="closeMenu">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
          ติดตามคำสั่งซื้อ
        </router-link>

        <template v-if="authStore.isAuthenticated">
          <router-link to="/member/profile" class="mobile-nav-link" @click="closeMenu">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            </svg>
            บัญชีของฉัน
          </router-link>
          <button @click="handleLogout" class="mobile-nav-link w-full text-left" style="color: #dc2626;">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
            </svg>
            ออกจากระบบ
          </button>
        </template>
        <template v-else>
          <router-link to="/login" class="mobile-nav-link" @click="closeMenu">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"/>
            </svg>
            เข้าสู่ระบบ
          </router-link>
          <router-link to="/register" class="mobile-nav-link" @click="closeMenu">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"/>
            </svg>
            สมัครสมาชิก
          </router-link>
        </template>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import { useCartStore } from '../stores/cart';
import { useAuthStore } from '../stores/auth';

const router = useRouter();
const cartStore = useCartStore();
const authStore = useAuthStore();

const showMenu = ref(false);

const openMenu = () => {
  showMenu.value = true;
  document.body.style.overflow = 'hidden';
};

const closeMenu = () => {
  showMenu.value = false;
  document.body.style.overflow = '';
};

const handleLogout = async () => {
  try {
    await authStore.logout();
    closeMenu();
    router.push('/');
  } catch (error) {
    console.error('Logout failed:', error);
  }
};

onMounted(() => {
  cartStore.fetchCart();
  authStore.fetchUser();
});

onUnmounted(() => {
  document.body.style.overflow = '';
});
</script>
